var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.392,
    height: 18.655,
    viewBox: "0 0 156.392 18.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Miverna_IOT_1",
    "data-name": "Miverna IOT 1",
    transform: "translate(-18 -31.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M18,32V50.536h2.839V39.181l6.763,6.6,9.6-9.6V32l-9.6,9.268Z",
    transform: "translate(0 -0.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M117,71.921V81.69h2.755V69.5Z",
    transform: "translate(-82.468 -31.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 2.413,
    height: 18.1,
    transform: "translate(42.867 31.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M211.5,69.5V81.69h2.672V72.506Z",
    transform: "translate(-161.187 -31.623)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M211.5,32.5v4.008l12.19,14.361H227.2V32.5h-2.839V47.7Z",
    transform: "translate(-161.187 -0.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M332.5,32.5l.167,18.369h2.839V32.5Z",
    transform: "translate(-261.981 -0.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 8.447,
    height: 2.413,
    transform: "translate(74.843 31.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 8.447,
    height: 3.017,
    transform: "translate(74.843 39.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 8.447,
    height: 2.413,
    transform: "translate(74.843 47.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M439.5,32.5V50.869l2.672.167V32.5Z",
    transform: "translate(-351.113 -0.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M464.667,42.427s7.181.835,6.847-4.342c0,0-.167-4.342-7.014-3.507V31.907s9.018-1.5,9.352,6.179A6.346,6.346,0,0,1,469.51,44.6l4.342,5.678h-3.34Z",
    transform: "translate(-371.938 -0.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M537,32.583h3.006l5.01,10.687,5.01-10.687,3.089-.083L545.1,50.7Z",
    transform: "translate(-432.331 -0.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M629.5,50.869,637.349,32.5,645.2,50.7h-2.839l-5.01-10.854-5.177,11.021Z",
    transform: "translate(-509.385 -0.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M669,126h2.5l.083,2.755h-2.5Z",
    transform: "translate(-542.288 -78.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 2.413,
    height: 18.1,
    transform: "translate(139.399 31.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 4.843,
    height: 2.505,
    transform: "translate(159.442 31.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 4.827,
    height: 2.413,
    transform: "translate(169.565 31.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 3.017,
    height: 18.1,
    transform: "translate(165.342 31.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M790.264,56a7.264,7.264,0,1,0,7.264,7.264A7.265,7.265,0,0,0,790.264,56Zm0,12.357a5.093,5.093,0,1,1,5.093-5.093A5.094,5.094,0,0,1,790.264,68.357Z",
    transform: "translate(-637.252 -20.377)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaLogoColor);
export default __webpack_public_path__ + "static/media/Minerva_LogoColor.da8af293e6a2b411207f1a570c09ae57.svg";
export { ForwardRef as ReactComponent };